module.exports = __webpack_public_path__ + "static/assets/ff51fd44978632fe6e26c64157f67a62.png";